<template>
  <card>
    <h5 slot="header" class="title">Update Profile Password</h5>
    <form>
      <div class="row">
        
        <div class="col-md-6" style="min-height: 275px;">
          <label for="password">Password</label>
          <password 
            v-model="model.password" 
            :secureLength="6"
            :toggle="true"
            :userInputs="dictionary"
            @feedback="showFeedback"/>

          <label for="password">Confirm Password</label>
          <password v-model="model.confirm_password" :showPassword="false" :secureLength="6"/>

          <n-button type="success" block @click.native="updatePassword">Update Password</n-button>
            
        </div>
        <div class="col-md-6">
          <label for="password" v-if="feedbacks && feedbacks.length > 0">Strength Suggestions</label>
          <ul class="suggestions">
              <li v-for="(sug, index) in feedbacks" :key="index">{{ sug }}</li>
              <li v-if="!isPasswordSame">Password and Confirm Password does not match.</li>
            </ul>
        </div>
        
      </div>
    </form>
  </card>
</template>
<script>
import Password from 'vue-password-strength-meter'
export default {
  components: { Password },
  data() {
    return {
      model: {
        password: '',
        confirm_password: ''
      },
      feedbacks: []
    };
  },
  computed: {
    dictionary(){
      let words = this.$currentUser.name.split(' ')
      return words
    },
    isPasswordSame(){
      return this.model.password == this.model.confirm_password
    }
  },
  methods: {
    updatePassword() {
      this.$store.dispatch('updatePassword', {
        password: this.model.password,
        user_id : this.$currentUser.user_id
      })

      this.model = { password: '', confirm_password : ''}
    },
    showFeedback ({suggestions, warning}) {
      this.feedbacks = suggestions
    }
  }
};
</script>
<style>
</style>
